const examples = [
  {
    bad: '«Развить лидерские качества»',
    good: '«Научиться самостоятельно проводить еженедельные встречи команды по установленной структуре и принимать решения по итогам встречи»',
  },
  {
    bad: '«Улучшить навыки переговоров»',
    good: '«Провести 5 переговоров по новой структуре, получить обратную связь руководителя и разобрать результаты»',
  },
  {
    bad: '«Развить навыки управления временем»',
    good: '«В течение 4 недель планировать рабочую неделю по согласованной системе и еженедельно анализировать выполнение приоритетных задач»',
  },
];

export default function GoodIPRExamples() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как выглядит хороший ИПР
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          От абстрактной цели к измеримому действию
        </p>

        <div className="space-y-5">
          {examples.map((ex, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 grid md:grid-cols-2 gap-4">
              <div className="bg-white border border-red-100 rounded-lg p-4">
                <div className="flex items-center gap-2 mb-2">
                  <i className="ri-close-circle-line text-red-500"></i>
                  <span className="text-xs font-semibold text-red-600 uppercase tracking-wide">Плохо</span>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed">{ex.bad}</p>
              </div>
              <div className="bg-white border border-teal-100 rounded-lg p-4">
                <div className="flex items-center gap-2 mb-2">
                  <i className="ri-checkbox-circle-line text-teal-600"></i>
                  <span className="text-xs font-semibold text-teal-700 uppercase tracking-wide">Лучше</span>
                </div>
                <p className="text-sm text-gray-700 leading-relaxed">{ex.good}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-teal-50 border border-teal-100 rounded-2xl p-6 md:p-8 text-center">
          <p className="text-base md:text-lg font-semibold text-gray-900 leading-relaxed">
            ИПР должен описывать не желание стать лучше, а конкретные действия и ожидаемый результат.
          </p>
        </div>
      </div>
    </section>
  );
}